export const preferencesNew = [
	{
		key: 1,
		code: "sex",
		items: [
			{
				key: 1,
				code: "69",
				category: "sex",
			},
			{
				key: 2,
				code: "bdsm",
				category: "sex",
			},
			{
				key: 3,
				code: "bisexual",
				category: "sex",
			},
			{
				key: 4,
				code: "bukkake",
				category: "sex",
			},
			{
				key: 5,
				code: "creampie",
				category: "sex",
			},
			{
				key: 6,
				code: "domination",
				category: "sex",
			},
			{
				key: 7,
				code: "fetishes",
				category: "sex",
			},
			{
				key: 8,
				code: "fisting",
				category: "sex",
			},
			{
				key: 9,
				code: "gang-bang",
				category: "sex",
			},
			{
				key: 10,
				code: "deep-throat",
				category: "sex",
			},
			{
				key: 11,
				code: "latex",
				category: "sex",
			},
			{
				key: 12,
				code: "massage",
				category: "sex",
			},
			{
				key: 13,
				code: "masturbation",
				category: "sex",
			},
			{
				key: 14,
				code: "naturism",
				category: "sex",
			},
			{
				key: 15,
				code: "hard-sex",
				category: "sex",
			},
			{
				key: 16,
				code: "perversions",
				category: "sex",
			},
			{
				key: 18,
				code: "swallowing",
				category: "sex",
			},
			{
				key: 19,
				code: "rimming",
				category: "sex",
			},
			{
				key: 20,
				code: "anal-sex",
				category: "sex",
			},
			{
				key: 21,
				code: "group-sex",
				category: "sex",
			},
			{
				key: 22,
				code: "classic-sex",
				category: "sex",
			},
			{
				key: 23,
				code: "oral-sex",
				category: "sex",
			},
			{
				key: 24,
				code: "sex-in-unusual-places",
				category: "sex",
			},
			{
				key: 25,
				code: "spanking",
				category: "sex",
			},
			{
				key: 26,
				code: "squirting",
				category: "sex",
			},
			{
				key: 27,
				code: "striptease",
				category: "sex",
			},
			{
				key: 28,
				code: "swingers",
				category: "sex",
			},
			{
				key: 29,
				code: "threesome-1w-2m",
				category: "sex",
			},
			{
				key: 30,
				code: "threesome-1m-2w",
				category: "sex",
			},
			{
				key: 31,
				code: "submissiveness",
				category: "sex",
			},
			{
				key: 32,
				code: "toys",
				category: "sex",
			},
			{
				key: 33,
				code: "face-fucking",
				category: "sex",
			},
			{
				key: 34,
				code: "high-heels",
				category: "sex",
			},
			{
				key: 35,
				code: "pregnancy",
				category: "sex",
			},
			{
				key: 36,
				code: "cuckold",
				category: "sex",
			},
			{
				key: 37,
				code: "experiments",
				category: "sex",
			},
			{
				key: 38,
				code: "carres",
				category: "sex",
			},
			{
				key: 39,
				code: "kisses",
				category: "sex",
			},
			{
				key: 40,
				code: "piercing",
				category: "sex",
			},
			{
				key: 41,
				code: "orgies",
				category: "sex",
			},
			{
				key: 42,
				code: "sexy-lingerie",
				category: "sex",
			},
			{
				key: 43,
				code: "stockings",
				category: "sex",
			},
			{
				key: 44,
				code: "tights",
				category: "sex",
			},
			{
				key: 45,
				code: "thong",
				category: "sex",
			},
			{
				key: 46,
				code: "strapon-sex",
				category: "sex",
			},
			{
				key: 47,
				code: "sex-in-the-car",
				category: "sex",
			},
			{
				key: 48,
				code: "bondage",
				category: "sex",
			},
			{
				key: 55,
				code: "exhibitionism",
				category: "sex",
			},
			{
				key: 60,
				code: "homosexual",
				category: "sex",
			},
			{
				key: 61,
				code: "heterosexual",
				category: "sex",
			},
			{
				key: 62,
				code: "conversation",
				category: "sex",
			},
			{
				key: 63,
				code: "scratching",
				category: "sex",
			},
			{
				key: 64,
				code: "biting",
				category: "sex",
			},
			{
				key: 65,
				code: "handcuffs",
				category: "sex",
			},
			{
				key: 66,
				code: "interracial",
				category: "sex",
			},
			{
				key: 67,
				code: "haired",
				category: "sex",
			},
			{
				key: 68,
				code: "depilation",
				category: "sex",
			},
			{
				key: 69,
				code: "virginity",
				category: "sex",
			},
			{
				key: 70,
				code: "photography",
				category: "sex",
			},
			{
				key: 71,
				code: "fake-nails",
				category: "sex",
			},
			{
				key: 72,
				code: "short-skirts",
				category: "sex",
			},
			{
				key: 75,
				code: "bodystocking",
				category: "sex",
			},
			{
				key: 76,
				code: "cunnilingus",
				category: "sex",
			},
			{
				key: 77,
				code: "sneakers",
				category: "sex",
			},
			{
				key: 78,
				code: "balls-licking",
				category: "sex",
			},
			{
				key: 79,
				code: "silicone-breast",
				category: "sex",
			},
			{
				key: 80,
				code: "footjob",
				category: "sex",
			},
			{
				key: 81,
				code: "handjob",
				category: "sex",
			},
			{
				key: 82,
				code: "facesitting",
				category: "sex",
			},
			{
				key: 83,
				code: "crossdressing",
				category: "sex",
			},
			{
				key: 84,
				code: "tattoos",
				category: "sex",
			},
			{
				key: 85,
				code: "selfsucking",
				category: "sex",
			},
			{
				key: 86,
				code: "choking",
				category: "sex",
			},
			{
				key: 87,
				code: "big-breasts",
				category: "sex",
			},
			{
				key: 88,
				code: "big-penis",
				category: "sex",
			},
			{
				key: 89,
				code: "peeping",
				category: "sex",
			},
			{
				key: 90,
				code: "cuckquean",
				category: "sex",
			},
			{
				key: 91,
				code: "bbw",
				category: "sex",
			},
			{
				key: 92,
				code: "small-penis",
				category: "sex",
			},
			{
				key: 93,
				code: "small-breasts",
				category: "sex",
			},
			{
				key: 94,
				code: "feet",
				category: "sex",
			},
			{
				key: 95,
				code: "cosplay",
				category: "sex",
			},
			{
				key: 96,
				code: "double-penetration",
				category: "sex",
			},
			{
				key: 97,
				code: "ddlg",
				category: "sex",
			},
			{
				key: 98,
				code: "ddlb",
				category: "sex",
			},
			{
				key: 99,
				code: "mdlg",
				category: "sex",
			},
			{
				key: 100,
				code: "mdlb",
				category: "sex",
			},
			{
				key: 101,
				code: "pegging",
				category: "sex",
			},
			{
				key: 103,
				code: "sapiosexual",
				category: "sex",
			},
			{
				key: 104,
				code: "metrosexual",
				category: "sex",
			},
			{
				key: 105,
				code: "beard",
				category: "sex",
			},
			{
				key: 106,
				code: "muscles",
				category: "sex",
			},
			{
				key: 107,
				code: "circumcised-penis",
				category: "sex",
			},
			{
				key: 108,
				code: "soft-sex",
				category: "sex",
			},
			{
				key: 109,
				code: "pole-dance",
				category: "sex",
			},
			{
				key: 110,
				code: "foreplay",
				category: "sex",
			},
			{
				key: 111,
				code: "big-ass",
				category: "sex",
			},
			{
				key: 112,
				code: "ballbusting",
				category: "sex",
			},
			{
				key: 113,
				code: "sex-party",
				category: "sex",
			},
			{
				key: 114,
				code: "recording-videos",
				category: "sex",
			},
			{
				key: 115,
				code: "moustache",
				category: "sex",
			},
			{
				key: 116,
				code: "blindfolding",
				category: "sex",
			},
			{
				key: 117,
				code: "nymphomania",
				category: "sex",
			},
			{
				key: 118,
				code: "unusual-positions",
				category: "sex",
			},
			{
				key: 119,
				code: "tantric-sex",
				category: "sex",
			},
			{
				key: 120,
				code: "age-difference",
				category: "sex",
			},
			{
				key: 121,
				code: "spanish-sex",
				category: "sex",
			},
			{
				key: 122,
				code: "harsh-words",
				category: "sex",
			},
			{
				key: 123,
				code: "role-playing",
				category: "sex",
			},
			{
				key: 124,
				code: "hair-pulling",
				category: "sex",
			},
			{
				key: 125,
				code: "petting",
				category: "sex",
			},
			{
				key: 126,
				code: "prostate-massage",
				category: "sex",
			},
			{
				key: 127,
				code: "shared-bath",
				category: "sex",
			},
			{
				key: 128,
				code: "love",
				category: "sex",
			},
			{
				key: 129,
				code: "cyber-sex",
				category: "sex",
			},
			{
				key: 130,
				code: "sexting",
				category: "sex",
			},
			{
				key: 131,
				code: "affair",
				category: "sex",
			},
			{
				key: 132,
				code: "flirt",
				category: "sex",
			},
			{
				key: 133,
				code: "discretion",
				category: "sex",
			},
			{
				key: 134,
				code: "friendship",
				category: "sex",
			},
			{
				key: 135,
				code: "joint-trips",
				category: "sex",
			},
			{
				key: 137,
				code: "events",
				category: "sex",
			},
			{
				key: 138,
				code: "video-calls",
				category: "sex",
			},
			{
				key: 139,
				code: "asexuality",
				category: "sex",
			},
			{
				key: 140,
				code: "monogamy",
				category: "sex",
			},
			{
				key: 141,
				code: "polyamory",
				category: "sex",
			},
			{
				key: 142,
				code: "hugging",
				category: "sex",
			},
			{
				key: 143,
				code: "tickling",
				category: "sex",
			},
		],
	},
	{
		key: 2,
		code: "sport",
		items: [
			{
				key: 154,
				code: "badminton",
				category: "sport",
			},
			{
				key: 158,
				code: "running",
				category: "sport",
			},
			{
				key: 159,
				code: "billiards",
				category: "sport",
			},
			{
				key: 161,
				code: "boxing",
				category: "sport",
			},
			{
				key: 165,
				code: "crossfit",
				category: "sport",
			},
			{
				key: 166,
				code: "skateboarding",
				category: "sport",
			},
			{
				key: 178,
				code: "fitness",
				category: "sport",
			},
			{
				key: 180,
				code: "rhythmic-gymnastics",
				category: "sport",
			},
			{
				key: 181,
				code: "go-karting",
				category: "sport",
			},
			{
				key: 182,
				code: "golf",
				category: "sport",
			},
			{
				key: 192,
				code: "hockey",
				category: "sport",
			},
			{
				key: 195,
				code: "horseback-riding",
				category: "sport",
			},
			{
				key: 197,
				code: "yoga",
				category: "sport",
			},
			{
				key: 199,
				code: "kayaking",
				category: "sport",
			},
			{
				key: 206,
				code: "kitesurfing",
				category: "sport",
			},
			{
				key: 211,
				code: "basketball",
				category: "sport",
			},
			{
				key: 225,
				code: "archery",
				category: "sport",
			},
			{
				key: 226,
				code: "ice-skating",
				category: "sport",
			},
			{
				key: 254,
				code: "skiing",
				category: "sport",
			},
			{
				key: 259,
				code: "diving",
				category: "sport",
			},
			{
				key: 264,
				code: "paintball",
				category: "sport",
			},
			{
				key: 266,
				code: "pilates",
				category: "sport",
			},
			{
				key: 267,
				code: "football-soccer",
				category: "sport",
			},
			{
				key: 271,
				code: "motorcycle-racing",
				category: "sport",
			},
			{
				key: 272,
				code: "swimming",
				category: "sport",
			},
			{
				key: 277,
				code: "pole-dance-interest",
				category: "sport",
			},
			{
				key: 285,
				code: "atvs-quads",
				category: "sport",
			},
			{
				key: 290,
				code: "rollerblading",
				category: "sport",
			},
			{
				key: 292,
				code: "cycling",
				category: "sport",
			},
			{
				key: 295,
				code: "rugby",
				category: "sport",
			},
			{
				key: 301,
				code: "volleyball",
				category: "sport",
			},
			{
				key: 302,
				code: "gym",
				category: "sport",
			},
			{
				key: 303,
				code: "skydiving",
				category: "sport",
			},
			{
				key: 306,
				code: "snowboarding",
				category: "sport",
			},
			{
				key: 309,
				code: "extreme-sports",
				category: "sport",
			},
			{
				key: 311,
				code: "squash",
				category: "sport",
			},
			{
				key: 313,
				code: "shooting",
				category: "sport",
			},
			{
				key: 315,
				code: "surfing",
				category: "sport",
			},
			{
				key: 318,
				code: "chess",
				category: "sport",
			},
			{
				key: 322,
				code: "martial-arts",
				category: "sport",
			},
			{
				key: 324,
				code: "dancing",
				category: "sport",
			},
			{
				key: 330,
				code: "tennis",
				category: "sport",
			},
			{
				key: 331,
				code: "table-tennis",
				category: "sport",
			},
			{
				key: 333,
				code: "trekking",
				category: "sport",
			},
			{
				key: 334,
				code: "triathlon",
				category: "sport",
			},
			{
				key: 343,
				code: "windsurfing",
				category: "sport",
			},
			{
				key: 346,
				code: "climbing",
				category: "sport",
			},
			{
				key: 347,
				code: "car-racing",
				category: "sport",
			},
			{
				key: 353,
				code: "zumba",
				category: "sport",
			},
			{
				key: 354,
				code: "sailing",
				category: "sport",
			},
		],
	},
	{
		key: 3,
		code: "hobby",
		items: [
			{
				key: 144,
				code: "acting",
				category: "hobby",
			},
			{
				key: 146,
				code: "aquaristics",
				category: "hobby",
			},
			{
				key: 148,
				code: "antiques",
				category: "hobby",
			},
			{
				key: 150,
				code: "astrology",
				category: "hobby",
			},
			{
				key: 151,
				code: "astronomy",
				category: "hobby",
			},
			{
				key: 153,
				code: "backpacking",
				category: "hobby",
			},
			{
				key: 156,
				code: "barista-skills",
				category: "hobby",
			},
			{
				key: 162,
				code: "ceramics",
				category: "hobby",
			},
			{
				key: 164,
				code: "cosplay-interest",
				category: "hobby",
			},
			{
				key: 167,
				code: "djing",
				category: "hobby",
			},
			{
				key: 170,
				code: "drones",
				category: "hobby",
			},
			{
				key: 172,
				code: "electronics",
				category: "hobby",
			},
			{
				key: 177,
				code: "philosophy",
				category: "hobby",
			},
			{
				key: 183,
				code: "cooking",
				category: "hobby",
			},
			{
				key: 184,
				code: "playing-instruments",
				category: "hobby",
			},
			{
				key: 185,
				code: "card-games",
				category: "hobby",
			},
			{
				key: 186,
				code: "computer-graphics",
				category: "hobby",
			},
			{
				key: 188,
				code: "video-games",
				category: "hobby",
			},
			{
				key: 189,
				code: "board-games",
				category: "hobby",
			},
			{
				key: 190,
				code: "mushroom-picking",
				category: "hobby",
			},
			{
				key: 191,
				code: "history",
				category: "hobby",
			},
			{
				key: 193,
				code: "influencing",
				category: "hobby",
			},
			{
				key: 196,
				code: "foreign-languages",
				category: "hobby",
			},
			{
				key: 200,
				code: "karaoke",
				category: "hobby",
			},
			{
				key: 205,
				code: "camping",
				category: "hobby",
			},
			{
				key: 207,
				code: "collecting",
				category: "hobby",
			},
			{
				key: 210,
				code: "cosmetology",
				category: "hobby",
			},
			{
				key: 212,
				code: "sewing",
				category: "hobby",
			},
			{
				key: 213,
				code: "bowling",
				category: "hobby",
			},
			{
				key: 214,
				code: "criminology",
				category: "hobby",
			},
			{
				key: 215,
				code: "crosswords",
				category: "hobby",
			},
			{
				key: 227,
				code: "magic",
				category: "hobby",
			},
			{
				key: 228,
				code: "diy",
				category: "hobby",
			},
			{
				key: 229,
				code: "makeup",
				category: "hobby",
			},
			{
				key: 232,
				code: "massage-interest",
				category: "hobby",
			},
			{
				key: 234,
				code: "natural-medicine",
				category: "hobby",
			},
			{
				key: 235,
				code: "meditation",
				category: "hobby",
			},
			{
				key: 238,
				code: "military-collectibles",
				category: "hobby",
			},
			{
				key: 240,
				code: "fashion",
				category: "hobby",
			},
			{
				key: 241,
				code: "model-making",
				category: "hobby",
			},
			{
				key: 242,
				code: "motorcycles",
				category: "hobby",
			},
			{
				key: 256,
				code: "science",
				category: "hobby",
			},
			{
				key: 260,
				code: "birdwatching",
				category: "hobby",
			},
			{
				key: 261,
				code: "gardening",
				category: "hobby",
			},
			{
				key: 265,
				code: "baking",
				category: "hobby",
			},
			{
				key: 268,
				code: "writing",
				category: "hobby",
			},
			{
				key: 274,
				code: "travel",
				category: "hobby",
			},
			{
				key: 276,
				code: "poker",
				category: "hobby",
			},
			{
				key: 278,
				code: "politics",
				category: "hobby",
			},
			{
				key: 280,
				code: "programming",
				category: "hobby",
			},
			{
				key: 283,
				code: "psychology",
				category: "hobby",
			},
			{
				key: 284,
				code: "puzzles",
				category: "hobby",
			},
			{
				key: 288,
				code: "handicrafts",
				category: "hobby",
			},
			{
				key: 291,
				code: "farming",
				category: "hobby",
			},
			{
				key: 294,
				code: "rpg-role-playing-games",
				category: "hobby",
			},
			{
				key: 296,
				code: "drawing",
				category: "hobby",
			},
			{
				key: 298,
				code: "cars",
				category: "hobby",
			},
			{
				key: 299,
				code: "sauna",
				category: "hobby",
			},
			{
				key: 307,
				code: "spa",
				category: "hobby",
			},
			{
				key: 308,
				code: "walking",
				category: "hobby",
			},
			{
				key: 314,
				code: "nail-styling",
				category: "hobby",
			},
			{
				key: 316,
				code: "survival",
				category: "hobby",
			},
			{
				key: 320,
				code: "hookah",
				category: "hobby",
			},
			{
				key: 323,
				code: "singing",
				category: "hobby",
			},
			{
				key: 325,
				code: "tarot",
				category: "hobby",
			},
			{
				key: 328,
				code: "technology",
				category: "hobby",
			},
			{
				key: 335,
				code: "jewelry-making",
				category: "hobby",
			},
			{
				key: 338,
				code: "weekend-getaways",
				category: "hobby",
			},
			{
				key: 341,
				code: "fishing",
				category: "hobby",
			},
			{
				key: 349,
				code: "shopping",
				category: "hobby",
			},
			{
				key: 352,
				code: "herbalism",
				category: "hobby",
			},
		],
	},
	{
		key: 4,
		code: "life_style",
		items: [
			{
				key: 145,
				code: "active-lifestyle",
				category: "life_style",
			},
			{
				key: 157,
				code: "bars-and-pubs",
				category: "life_style",
			},
			{
				key: 163,
				code: "clubbing",
				category: "life_style",
			},
			{
				key: 168,
				code: "home-comfort",
				category: "life_style",
			},
			{
				key: 171,
				code: "ecology",
				category: "life_style",
			},
			{
				key: 174,
				code: "feminism",
				category: "life_style",
			},
			{
				key: 194,
				code: "investing",
				category: "life_style",
			},
			{
				key: 201,
				code: "career",
				category: "life_style",
			},
			{
				key: 203,
				code: "cafes-and-restaurants",
				category: "life_style",
			},
			{
				key: 224,
				code: "luxury",
				category: "life_style",
			},
			{
				key: 239,
				code: "minimalism",
				category: "life_style",
			},
			{
				key: 255,
				code: "naturalness",
				category: "life_style",
			},
			{
				key: 257,
				code: "networking",
				category: "life_style",
			},
			{
				key: 258,
				code: "nightlife",
				category: "life_style",
			},
			{
				key: 279,
				code: "work",
				category: "life_style",
			},
			{
				key: 281,
				code: "entrepreneurship",
				category: "life_style",
			},
			{
				key: 282,
				code: "nature",
				category: "life_style",
			},
			{
				key: 287,
				code: "religion",
				category: "life_style",
			},
			{
				key: 289,
				code: "parenting",
				category: "life_style",
			},
			{
				key: 293,
				code: "personal-development",
				category: "life_style",
			},
			{
				key: 310,
				code: "meeting-with-friends",
				category: "life_style",
			},
			{
				key: 326,
				code: "tattoos-interest",
				category: "life_style",
			},
			{
				key: 332,
				code: "conspiracy-theories",
				category: "life_style",
			},
			{
				key: 336,
				code: "beauty",
				category: "life_style",
			},
			{
				key: 337,
				code: "substances",
				category: "life_style",
			},
			{
				key: 345,
				code: "volunteering",
				category: "life_style",
			},
			{
				key: 351,
				code: "health",
				category: "life_style",
			},
			{
				key: 355,
				code: "living-on-the-edge",
				category: "life_style",
			},
		],
	},
	{
		key: 5,
		code: "culture",
		items: [
			{
				key: 147,
				code: "anime-and-manga",
				category: "culture",
			},
			{
				key: 149,
				code: "architecture",
				category: "culture",
			},
			{
				key: 152,
				code: "audiobooks",
				category: "culture",
			},
			{
				key: 155,
				code: "ballet",
				category: "culture",
			},
			{
				key: 160,
				code: "blogging",
				category: "culture",
			},
			{
				key: 175,
				code: "festivals",
				category: "culture",
			},
			{
				key: 176,
				code: "film",
				category: "culture",
			},
			{
				key: 179,
				code: "photography-interest",
				category: "culture",
			},
			{
				key: 198,
				code: "cabaret",
				category: "culture",
			},
			{
				key: 208,
				code: "comics",
				category: "culture",
			},
			{
				key: 209,
				code: "concerts",
				category: "culture",
			},
			{
				key: 222,
				code: "literature",
				category: "culture",
			},
			{
				key: 230,
				code: "painting",
				category: "culture",
			},
			{
				key: 233,
				code: "social-media",
				category: "culture",
			},
			{
				key: 236,
				code: "memes",
				category: "culture",
			},
			{
				key: 243,
				code: "museums",
				category: "culture",
			},
			{
				key: 244,
				code: "alternative-music",
				category: "culture",
			},
			{
				key: 245,
				code: "country-music",
				category: "culture",
			},
			{
				key: 246,
				code: "disco-music",
				category: "culture",
			},
			{
				key: 247,
				code: "jazz-music",
				category: "culture",
			},
			{
				key: 248,
				code: "classical-music",
				category: "culture",
			},
			{
				key: 249,
				code: "metal-music",
				category: "culture",
			},
			{
				key: 250,
				code: "pop-music",
				category: "culture",
			},
			{
				key: 251,
				code: "rap-music",
				category: "culture",
			},
			{
				key: 252,
				code: "rock-music",
				category: "culture",
			},
			{
				key: 253,
				code: "techno-music",
				category: "culture",
			},
			{
				key: 262,
				code: "opera",
				category: "culture",
			},
			{
				key: 273,
				code: "podcasts",
				category: "culture",
			},
			{
				key: 275,
				code: "poetry",
				category: "culture",
			},
			{
				key: 297,
				code: "sculpting",
				category: "culture",
			},
			{
				key: 300,
				code: "tv-series",
				category: "culture",
			},
			{
				key: 312,
				code: "stand-up-comedy",
				category: "culture",
			},
			{
				key: 321,
				code: "art",
				category: "culture",
			},
			{
				key: 327,
				code: "theater",
				category: "culture",
			},
			{
				key: 329,
				code: "television",
				category: "culture",
			},
		],
	},
	{
		key: 6,
		code: "food",
		items: [
			{
				key: 169,
				code: "drinks",
				category: "food",
			},
			{
				key: 173,
				code: "fast-food",
				category: "food",
			},
			{
				key: 187,
				code: "barbecue",
				category: "food",
			},
			{
				key: 202,
				code: "coffee",
				category: "food",
			},
			{
				key: 204,
				code: "kebab",
				category: "food",
			},
			{
				key: 216,
				code: "asian-cuisine",
				category: "food",
			},
			{
				key: 217,
				code: "middle-eastern-cuisine",
				category: "food",
			},
			{
				key: 218,
				code: "homemade-cooking",
				category: "food",
			},
			{
				key: 219,
				code: "indian-cuisine",
				category: "food",
			},
			{
				key: 220,
				code: "mexican-cuisine",
				category: "food",
			},
			{
				key: 221,
				code: "italian-cuisine",
				category: "food",
			},
			{
				key: 223,
				code: "ice-cream",
				category: "food",
			},
			{
				key: 231,
				code: "monkeys",
				category: "food",
			},
			{
				key: 237,
				code: "meat",
				category: "food",
			},
			{
				key: 263,
				code: "seafood",
				category: "food",
			},
			{
				key: 269,
				code: "beer",
				category: "food",
			},
			{
				key: 270,
				code: "pizza",
				category: "food",
			},
			{
				key: 286,
				code: "ramen",
				category: "food",
			},
			{
				key: 304,
				code: "slow-food",
				category: "food",
			},
			{
				key: 305,
				code: "sweets",
				category: "food",
			},
			{
				key: 317,
				code: "sushi",
				category: "food",
			},
			{
				key: 319,
				code: "champagne",
				category: "food",
			},
			{
				key: 339,
				code: "veganism",
				category: "food",
			},
			{
				key: 340,
				code: "vegetarianism",
				category: "food",
			},
			{
				key: 342,
				code: "whisky",
				category: "food",
			},
			{
				key: 344,
				code: "wine",
				category: "food",
			},
			{
				key: 348,
				code: "yerba-mate",
				category: "food",
			},
			{
				key: 350,
				code: "healthy-food",
				category: "food",
			},
		],
	},
];
